<!--
  미묘 아트숍 이용약관 (2026-09-07 시행)
  법무 검토 완료 원문을 그대로 옮긴 파일이다 (mimio#46). 이 파일이 곧 원문이므로
  표현·기호를 임의로 손대지 말 것 — 개정 시 새 시행일 파일을 추가하고 버전 탭에 붙인다.
-->
<template>
  <div class="policy-txt white-space-pre-line">
    <div class="terms-text bold">제1조(목적 및 서비스의 제공)</div>
    <div class="terms-text">① 이 약관은 아티클21 주식회사(이하 “회사”라 합니다)가 운영하는 온라인 플랫폼 미묘(mimio.life)(이하 “미묘”라 합니다)의 전자상거래 서비스(이하 “아트숍”이라 합니다)을 통하여 제공하는 상품 및 서비스의 구매와 관련하여 회사와 이용자 간의 권리와 의무, 책임 사항, 구매 절차 및 기타 필요한 사항을 규정함을 목적으로 합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제2조(정의)</div>
    <div class="terms-text">① 이 약관에서 사용하는 용어의 뜻은 다음과 같습니다.</div>
    <div class="terms-text indent1">1. “아트숍”이란 회사가 운영하는 미묘의 온라인 스토어로서 시각예술 작품 및 아트 상품, 디지털 콘텐츠 및 기타 예술 관련 상품을 거래할 수 있도록 제공하는 서비스를 말합니다.</div>
    <div class="terms-text indent1">2. “이용자”란 미묘에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</div>
    <div class="terms-text indent1">3. “회원”이란 「미묘 이용약관」에 따라 회원 가입을 완료하고 회사가 제공하는 서비스를 지속적으로 이용하는 자를 말합니다.</div>
    <div class="terms-text indent1">4. “판매자”란 회사 또는 회사의 승인을 받아 아트숍에서 상품을 판매하는 작가, 법인 또는 개인사업자를 말합니다.</div>
    <div class="terms-text indent1">5. “구매자”란 아트숍에서 상품 또는 서비스를 구매하거나 구매를 신청하는 이용자를 말합니다.</div>
    <div class="terms-text indent1">6. “상품”이란 아트숍에서 판매되는 미술 작품, 원화, 판화, 아트 프린트, 굿즈, 디지털 콘텐츠 및 기타 회사 또는 판매자가 제공하는 재화 또는 용역을 말합니다.</div>
    <div class="terms-text indent1">7. “주문제작 상품”이란 구매자의 주문 이후 제작되거나 맞춤 제작되는 상품을 말합니다.</div>
    <div class="terms-text indent1">8. “디지털 상품”이란 다운로드 또는 온라인 방식으로 제공되는 이미지, 파일, 라이선스, 전자문서 등 유형물이 아닌 상품을 말합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제3조(약관의 게시 및 개정)</div>
    <div class="terms-text">① 회사는 이 약관의 내용, 상호, 대표자, 사업자등록번호, 통신판매업 신고번호, 고객센터 연락처 및 기타 법령에서 요구하는 사항을 이용자가 쉽게 확인할 수 있도록 아트숍 화면에 게시합니다.</div>
    <div class="terms-text">② 회사는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래 기본법」, 「전자금융거래법」, 「소비자기본법」 및 관계 법령을 위반하지 않는 범위에서 이 약관을 개정할 수 있습니다.</div>
    <div class="terms-text">③ 회사가 약관을 개정하는 경우에는 적용일자와 개정 사유를 명시하여 적용일 7일 전부터 공지합니다. 다만, 이용자에게 불리한 변경의 경우에는 적용일 30일 전까지 공지하고, 전자우편, 서비스 내 알림 등 이용자가 그 내용을 확인할 수 있는 전자적 수단으로 개별적으로 통지합니다.</div>
    <div class="terms-text">④ 개정된 약관은 적용일 이후 체결되는 계약부터 적용되며, 이미 체결된 계약에 대하여는 개정 전의 약관이 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관의 적용을 받기를 원하는 뜻을 회사에 표시하고 회사가 이에 동의한 경우에는 개정약관을 적용합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제4조(아트숍 서비스의 제공)</div>
    <div class="terms-text">① 회사는 다음 각 호의 서비스를 제공합니다.</div>
    <div class="terms-text indent1">1. 상품의 전시 및 정보 제공</div>
    <div class="terms-text indent1">2. 상품의 주문 및 구매계약 체결</div>
    <div class="terms-text indent1">3. 결제 서비스 제공</div>
    <div class="terms-text indent1">4. 상품의 배송 또는 디지털 상품 제공</div>
    <div class="terms-text indent1">5. 주문 및 배송 현황 조회</div>
    <div class="terms-text indent1">6. 교환·환불 및 고객지원 서비스</div>
    <div class="terms-text indent1">7. 기타 회사가 정하는 서비스</div>
    <div class="terms-text">② 회사는 서비스의 품질 향상 또는 운영상 필요에 따라 서비스의 일부를 변경하거나 추가할 수 있습니다.</div>
    <div class="terms-text">③ 회사는 시스템 점검, 설비 보수, 천재지변 또는 기타 불가피한 사유가 발생한 경우 서비스의 전부 또는 일부를 일시적으로 중단할 수 있습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제5조(판매자의 지위)</div>
    <div class="terms-text">① 아트숍에서 판매되는 상품의 판매자는 상품 상세페이지에 표시된 판매자입니다.</div>
    <div class="terms-text">② 회사는 판매자와 구매자 간 거래가 이루어질 수 있도록 플랫폼, 결제 및 정산 서비스를 제공합니다.</div>
    <div class="terms-text">③ 구매자는 회사가 지정한 결제수단을 통하여 상품 대금을 회사에 지급하며, 회사는 판매자가 계약을 이행한 후 판매 대금에서 수수료 등 약정된 금액을 공제한 나머지를 판매자에게 정산합니다.</div>
    <div class="terms-text">④ 상품의 매매 계약은 구매자와 판매자 사이에 체결됩니다. 회사가 판매자가 아닌 상품에 관하여 회사는 「전자상거래 등에서의 소비자보호에 관한 법률」상 통신판매중개자로서, 자신이 통신판매의 당사자가 아니라는 사실을 상품 상세페이지 등 구매자가 쉽게 알 수 있는 방법으로 미리 고지합니다. 다만 회사가 직접 기획·제작하여 판매하는 상품에 관하여는 회사가 판매자(통신판매업자)로서 책임을 부담합니다.</div>
    <div class="terms-text">⑤ 회사는 판매자가 사업자인 경우 그 성명(법인인 경우 상호와 대표자의 성명)·주소·전화번호 등 관계 법령에서 정한 판매자의 신원정보를, 판매자가 사업자가 아닌 경우 그 성명·전화번호 등의 정보를 확인하여 구매자에게 제공하거나 구매자가 열람할 수 있는 방법을 제공합니다.</div>
    <div class="terms-text">⑥ 회사는 아트숍에서 청약의 접수를 받거나 상품 대금을 지급받는 업무를 수행하는 범위에서 「전자상거래 등에서의 소비자보호에 관한 법률」 제20조의3에 따라 그 업무에 관한 통신판매업자의 책임을 부담합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제6조(이용약관과의 관계)</div>
    <div class="terms-text">① 이 약관은 미묘 이용약관의 특별약관으로서 아트숍 이용에 적용됩니다.</div>
    <div class="terms-text">② 이 약관에서 정하지 아니한 사항은 「미묘 이용약관」 및 관계 법령에 따릅니다.</div>
    <div class="terms-text">③ 미묘 이용약관과 이 약관의 내용이 서로 다른 경우에는 아트숍 이용에 관하여는 이 약관을 우선 적용합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제7조(상품의 표시)</div>
    <div class="terms-text">① 회사 또는 판매자는 상품의 명칭, 가격, 판매자 정보, 주요 사양, 구성, 배송방법, 배송비, 교환·환불 조건 등 구매에 필요한 정보를 관련 법령에 따라 표시합니다.</div>
    <div class="terms-text">② 작품 이미지는 이해를 돕기 위한 것으로, 촬영 환경, 조명, 모니터 또는 모바일 기기의 설정 등에 따라 실제 상품의 색상, 질감 또는 크기와 차이가 있을 수 있습니다.</div>
    <div class="terms-text">③ 원화, 수공예품, 에디션 작품 및 주문제작 상품은 제작 과정 또는 작품의 특성에 따라 미세한 차이가 발생할 수 있으며, 이는 하자로 보지 않습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제8조(구매 신청)</div>
    <div class="terms-text">① 이용자는 아트숍에서 다음 절차에 따라 상품을 구매할 수 있습니다.</div>
    <div class="terms-text indent1">1. 상품 선택</div>
    <div class="terms-text indent1">2. 구매 수량 및 옵션 선택</div>
    <div class="terms-text indent1">3. 주문자 및 배송정보 입력</div>
    <div class="terms-text indent1">4. 약관 및 개인정보 제공 등에 대한 동의</div>
    <div class="terms-text indent1">5. 결제수단 선택</div>
    <div class="terms-text indent1">6. 구매 신청</div>
    <div class="terms-text">② 회사는 이용자가 구매신청을 하기 전에 다음 사항을 명확하게 안내합니다.</div>
    <div class="terms-text indent1">1. 상품의 주요 내용</div>
    <div class="terms-text indent1">2. 판매 가격</div>
    <div class="terms-text indent1">3. 배송비 및 추가 비용</div>
    <div class="terms-text indent1">4. 청약철회 가능 여부</div>
    <div class="terms-text indent1">5. 교환 및 환불 조건</div>
    <div class="terms-text indent1">6. 주문제작 또는 디지털 상품 여부</div>
    <div class="terms-text">③ 회사는 구매자의 편의를 위하여 관련 법령이 허용하는 범위에서 주문 절차를 변경하거나 간소화할 수 있습니다.</div>
    <div class="terms-text">④ 회사 또는 판매자는 미성년자와 상품의 구매계약을 체결하는 경우, 법정대리인이 그 계약에 동의하지 아니하면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약 체결 전에 구매자에게 고지합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제9조(계약의 성립)</div>
    <div class="terms-text">① 구매계약은 이용자의 구매신청에 대하여 회사 또는 판매자가 이를 승낙하고 주문확인 또는 결제완료 안내를 한 때 성립합니다.</div>
    <div class="terms-text">② 다음 각 호의 경우 회사는 구매신청을 승낙하지 않거나 계약을 취소할 수 있습니다.</div>
    <div class="terms-text indent1">1. 신청 내용에 허위가 있는 경우</div>
    <div class="terms-text indent1">2. 결제 승인이 이루어지지 않은 경우</div>
    <div class="terms-text indent1">3. 재고 부족 또는 제작 불가가 확인된 경우</div>
    <div class="terms-text indent1">4. 가격의 명백한 입력 오류가 있는 경우</div>
    <div class="terms-text indent1">5. 시스템 오류로 정상적인 거래가 불가능한 경우</div>
    <div class="terms-text indent1">6. 기타 관련 법령 또는 약관을 위반한 경우</div>
    <div class="terms-text">③ 회사가 계약을 취소하는 경우에는 그 사유를 이용자에게 지체 없이 안내하고 이미 지급받은 대금이 있는 경우에는 관련 법령에 따라 환불합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제10조(결제)</div>
    <div class="terms-text">① 이용자는 회사가 제공하는 다음 각 호의 방법으로 상품 대금을 결제할 수 있습니다.</div>
    <div class="terms-text indent1">1. 신용카드 및 체크카드</div>
    <div class="terms-text indent1">2. 계좌이체</div>
    <div class="terms-text indent1">3. 간편결제</div>
    <div class="terms-text indent1">4. 전자지급수단</div>
    <div class="terms-text indent1">5. 무통장입금</div>
    <div class="terms-text indent1">6. 기타 회사가 제공하는 결제수단</div>
    <div class="terms-text">② 회사는 결제수단에 따라 필요한 본인확인 또는 인증절차를 요구할 수 있습니다.</div>
    <div class="terms-text">③ 회사는 결제와 관련하여 이용자에게 법령상 허용되지 않는 별도의 수수료를 부과하지 않습니다.</div>
    <div class="terms-text">④ 회사는 구매자가 무통장입금 등 현금성 결제수단으로 대금을 선지급하는 거래에 관하여 「전자상거래 등에서의 소비자보호에 관한 법률」 제24조에 따른 결제대금예치(에스크로) 서비스 또는 소비자피해보상보험계약 등 구매안전서비스를 제공하고, 그 이용 방법을 결제 화면에서 안내합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제11조(주문의 변경 및 취소)</div>
    <div class="terms-text">① 이용자는 상품이 발송되기 전까지 주문을 변경하거나 취소할 수 있습니다.</div>
    <div class="terms-text">② 판매자가 주문제작을 시작하였거나 배송이 개시된 이후에는 관련 법령 또는 본 약관에서 정한 경우를 제외하고 주문의 변경 또는 취소가 제한될 수 있습니다.</div>
    <div class="terms-text">③ 디지털 상품은 다운로드 또는 제공이 개시된 이후에는 관련 법령에서 인정하는 경우를 제외하고 주문취소가 제한될 수 있습니다.</div>
    <div class="terms-text">④ 회사 또는 판매자는 주문취소가 완료된 경우 결제수단에 따라 환불 절차를 진행합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제12조(재고 부족 및 주문취소)</div>
    <div class="terms-text">① 재고 부족, 제작 불가, 판매 종료, 천재지변 또는 기타 불가피한 사유로 상품을 공급할 수 없는 경우 회사 또는 판매자는 구매자에게 즉시 그 사실을 알립니다.</div>
    <div class="terms-text">② 이미 결제가 완료된 경우에는 관련 법령에 따라 지체 없이 환불하거나 환불에 필요한 조치를 합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제13조(상품의 공급 및 배송)</div>
    <div class="terms-text">① 회사 또는 판매자는 별도의 약정이 없는 한 구매계약이 성립한 날부터 합리적인 기간 내에 상품을 발송하도록 노력합니다.</div>
    <div class="terms-text">② 상품의 특성에 따라 제작 기간 또는 배송기간이 별도로 안내된 경우에는 안내된 기간을 적용합니다.</div>
    <div class="terms-text">③ 주문제작 상품, 예약판매 상품 또는 해외배송 상품은 일반 상품보다 제작 또는 배송에 추가 기간이 소요될 수 있습니다.</div>
    <div class="terms-text">④ 회사 또는 판매자는 배송 지연이 예상되는 경우 그 사유와 예정 일정을 구매자에게 안내합니다.</div>
    <div class="terms-text">⑤ 디지털 상품은 결제가 완료된 후 다운로드, 이메일 발송 또는 온라인 제공 등의 방법으로 공급할 수 있습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제14조(배송 완료 및 위험의 이전)</div>
    <div class="terms-text">① 상품의 멸실 또는 훼손 위험은 구매자가 상품을 인도받은 시점부터 구매자에게 이전됩니다.</div>
    <div class="terms-text">② 배송 중 발생한 분실 또는 파손으로 인하여 상품을 정상적으로 인도할 수 없는 경우에는 회사 또는 판매자가 관련 법령에 따라 필요한 조치를 합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제15조(청약철회)</div>
    <div class="terms-text">① 구매자는 「전자상거래 등에서의 소비자보호에 관한 법률」이 정하는 바에 따라 상품을 공급받은 날부터 7일 이내에 청약철회를 할 수 있습니다.</div>
    <div class="terms-text">② 다음 각 호의 어느 하나에 해당하는 경우에는 청약철회가 제한될 수 있습니다.</div>
    <div class="terms-text indent1">1. 구매자의 책임 있는 사유로 상품이 훼손된 경우</div>
    <div class="terms-text indent1">2. 구매자의 사용 또는 소비로 상품의 가치가 현저히 감소한 경우</div>
    <div class="terms-text indent1">3. 시간이 지나 다시 판매하기 곤란할 정도로 상품의 가치가 현저히 낮아진 경우</div>
    <div class="terms-text indent1">4. 복제가 가능한 상품의 포장을 훼손한 경우</div>
    <div class="terms-text indent1">5. 관련 법령에서 청약철회가 제한되는 경우</div>
    <div class="terms-text">③ 회사 또는 판매자가 청약철회의 제한 사실을 관련 법령에 따라 명확하게 고지하지 않은 경우에는 제2항에도 불구하고 청약철회가 제한되지 않습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제16조(주문제작 상품의 특칙)</div>
    <div class="terms-text">① 구매자의 요청에 따라 개별적으로 제작되는 주문제작 상품으로서 청약철회를 인정하는 경우 판매자에게 회복할 수 없는 피해가 예상되는 경우에는, 회사 또는 판매자가 사전에 해당 거래에 대하여 청약철회가 제한된다는 사실을 별도로 고지하고 구매자의 서면(전자문서를 포함합니다)에 의한 동의를 받은 때에 한하여 단순 변심에 의한 주문취소 또는 청약철회가 제한됩니다.</div>
    <div class="terms-text">② 주문제작 상품에 하자가 있거나 계약 내용과 다르게 제작된 경우에는 구매자는 관련 법령에 따라 교환, 환불 또는 손해배상을 요구할 수 있습니다.</div>
    <div class="terms-text">③ 회사 또는 판매자는 주문제작 상품에 대한 청약철회 제한 여부를 상품 상세페이지에 명확히 표시합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제17조(디지털 상품의 특칙)</div>
    <div class="terms-text">① 다운로드, 라이선스 제공 또는 온라인 방식으로 공급되는 디지털 상품은 공급이 개시된 이후에는 관련 법령이 허용하는 범위에서 청약철회가 제한될 수 있습니다.</div>
    <div class="terms-text">② 회사 또는 판매자는 청약철회가 제한되는 디지털 상품의 경우 공급이 개시되기 전에 그 사실을 구매자가 쉽게 알 수 있는 곳에 명확하게 표시하고, 시험 사용 상품을 제공하는 등 구매자의 청약철회 등의 권리 행사가 방해받지 아니하도록 필요한 조치를 합니다. 다만 나누어 공급할 수 있는 디지털 상품의 경우 공급이 개시되지 아니한 부분에 대하여는 청약철회가 제한되지 아니합니다.</div>
    <div class="terms-text">③ 디지털 상품에 중대한 하자가 있거나 계약 내용과 다르게 제공된 경우에는 구매자는 관련 법령에 따라 환불 또는 재공급을 요구할 수 있습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제18조(교환 및 환불)</div>
    <div class="terms-text">① 상품에 하자가 있거나 계약 내용과 다르게 공급된 경우 회사 또는 판매자는 관련 법령에 따라 교환, 환불 또는 재배송 등의 조치를 합니다.</div>
    <div class="terms-text">② 단순 변심에 따른 교환 또는 환불의 배송비는 관련 법령 또는 상품 안내에서 달리 정하지 않는 한 구매자가 부담합니다.</div>
    <div class="terms-text">③ 상품의 하자 또는 오배송으로 인한 교환 및 환불 비용은 회사 또는 판매자가 부담합니다.</div>
    <div class="terms-text">④ 환불은 구매자가 이용한 결제수단과 동일하거나 이에 준하는 방법으로 처리합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제19조(환급)</div>
    <div class="terms-text">① 회사 또는 판매자는 구매자가 청약철회 등을 한 경우 상품을 반환받은 날(상품의 반환이 필요하지 아니한 디지털 상품 등의 경우에는 청약철회 등의 의사표시를 받은 날)부터 3영업일 이내에 이미 지급받은 대금을 환급하고, 환급이 지연되는 때에는 그 지연기간에 대하여 관계 법령이 정하는 이율에 따른 지연배상금을 지급합니다.</div>
    <div class="terms-text">② 신용카드 등 결제수단으로 결제한 경우에는 해당 결제사업자에게 결제취소 또는 환급 절차를 요청합니다.</div>
    <div class="terms-text">③ 환불이 지연되는 경우에는 관련 법령에서 정하는 바에 따라 처리합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제20조(회사의 의무)</div>
    <div class="terms-text">① 회사는 관련 법령과 이 약관이 정하는 바에 따라 안정적이고 지속적으로 아트숍 서비스를 제공하기 위하여 노력합니다.</div>
    <div class="terms-text">② 회사는 이용자의 개인정보를 관련 법령 및 「미묘 개인정보 처리방침」에 따라 안전하게 보호합니다.</div>
    <div class="terms-text">③ 회사는 이용자가 안전하게 서비스를 이용할 수 있도록 필요한 기술적·관리적 보호조치를 마련합니다.</div>
    <div class="terms-text">④ 회사는 이용자의 정당한 의견 또는 불만을 신속하게 처리하기 위하여 고객지원 절차를 운영합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제21조(판매자의 의무)</div>
    <div class="terms-text">① 판매자는 관계 법령 및 본 약관을 준수하여 상품을 판매하여야 합니다.</div>
    <div class="terms-text">② 판매자는 상품의 품질, 규격, 가격, 제작기간, 배송조건, 교환·환불 조건 등을 정확하게 표시하여야 합니다.</div>
    <div class="terms-text">③ 판매자는 판매하는 상품이 제3자의 저작권, 상표권 또는 기타 권리를 침해하지 않음을 보증하여야 합니다.</div>
    <div class="terms-text">④ 판매자는 상품의 하자, 오배송 또는 계약 내용과 다른 이행으로 인하여 발생하는 책임을 관계 법령에 따라 부담합니다.</div>
    <div class="terms-text">⑤ 판매자는 「미술진흥법」에 따른 미술서비스업 신고 등 상품의 판매·유통에 필요한 관계 법령상의 신고·등록을 이행하여야 하며, 회사는 판매자에게 이를 확인할 수 있는 자료의 제출을 요청할 수 있습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제22조(구매자의 의무)</div>
    <div class="terms-text">① 구매자는 관련 법령, 본 약관 및 회사가 안내하는 사항을 준수하여야 합니다.</div>
    <div class="terms-text">② 구매자는 허위 주문, 부정결제, 타인의 정보 도용 또는 기타 부정한 방법으로 서비스를 이용하여서는 아니 됩니다.</div>
    <div class="terms-text">③ 구매자는 상품의 교환 또는 환불 절차에서 허위 사실을 주장하거나 부당한 요구를 하여서는 아니 됩니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제23조(회사의 책임 제한)</div>
    <div class="terms-text">① 회사는 플랫폼 운영, 결제 및 판매대금 정산 서비스를 제공합니다.</div>
    <div class="terms-text">② 상품의 품질, 진품 여부, 제작, 배송, 하자, 교환 및 환불 등 판매계약의 이행에 관한 책임은 원칙적으로 판매자가 부담합니다. 다만 회사가 판매자인 상품의 경우와 회사가 「전자상거래 등에서의 소비자보호에 관한 법률」 제20조, 제20조의2 및 제20조의3에 따라 부담하는 책임은 본 조에 의하여 면제되지 아니합니다.</div>
    <div class="terms-text">③ 회사는 구매자 보호를 위하여 판매대금을 회사의 고유재산과 구분하여 관리하고, 배송 완료·구매확정 등 정산 조건이 충족된 날부터 회사와 판매자 간 계약에서 정한 기한(구매확정일부터 [30]일 이내) 내에 수수료 등 약정된 금액을 공제한 판매대금을 판매자에게 지급합니다.</div>
    <div class="terms-text">④ 회사는 거래의 안전을 위하여 필요한 경우 정산을 보류하거나 증빙자료를 요청하는 등 합리적인 조치를 취할 수 있습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제24조(회원에 대한 통지)</div>
    <div class="terms-text">① 회사는 이용자에게 전자우편, 문자메시지, 서비스 내 알림 또는 기타 전자적 방법으로 통지할 수 있습니다.</div>
    <div class="terms-text">② 불특정 다수의 이용자에게 하는 통지는 서비스 화면에 7일 이상 게시함으로써 개별 통지를 갈음할 수 있습니다. 다만, 이용자의 권리·의무에 중대한 영향을 미치는 사항은 개별적으로 통지합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제25조(분쟁의 해결)</div>
    <div class="terms-text">① 회사는 이용자의 정당한 의견과 불만을 신속하고 공정하게 처리하기 위하여 필요한 절차를 마련합니다.</div>
    <div class="terms-text">② 회사와 이용자 간 분쟁이 발생하는 경우 당사자는 상호 협의를 통하여 원만하게 해결하도록 노력합니다.</div>
    <div class="terms-text">③ 협의로 해결되지 않는 경우에는 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관계 법령에 따른 분쟁조정기관의 조정을 신청할 수 있습니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">제26조(준거법 및 관할법원)</div>
    <div class="terms-text">① 이 약관의 해석 및 적용에는 대한민국 법령을 적용합니다.</div>
    <div class="terms-text">② 회사와 이용자 사이에 발생한 소송은 관계 법령에서 달리 정한 경우를 제외하고 민사소송법에 따른 관할법원을 제1심 관할법원으로 합니다.</div>
    <div class="terms-text"></div><br>
    <div class="terms-text bold">부칙</div>
    <div class="terms-text"></div><br>
    <div class="terms-text">이 약관은 2026년 9월 7일부터 시행합니다.</div>
  </div>
</template>

<style scoped>
.terms-text {
  line-height: 1.8;
  margin-bottom: 8px;
}

.bold {
  font-weight: bold;
}

.indent1 {
  padding-left: 10px;
}

.indent2 {
  padding-left: 20px;
}
</style>
